// extracted by mini-css-extract-plugin
module.exports = {"container":"pointsTable_container__2Ai8b","team":"pointsTable_team__20Dhw","loader":"pointsTable_loader__3lYUQ"};